import { render } from "./VerifyNumber.vue?vue&type=template&id=f32a0eb0&scoped=true"
import script from "./VerifyNumber.vue?vue&type=script&lang=js"
export * from "./VerifyNumber.vue?vue&type=script&lang=js"

import "./VerifyNumber.vue?vue&type=style&index=0&id=f32a0eb0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f32a0eb0"]])

export default __exports__